import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  appPageTableHeader: {
    top: 124,
    zIndex: 1,
    height: 38,
    backgroundColor: "#fff",
    borderBottom: `1px solid ${theme.palette.text.hint}`,
    "& $rowContent": {
      height: "auto"
    },
    [theme.breakpoints.down("xs")]: {
      top: 104
    }
  },
  appPageTableRow: {
    height: 46,
    borderBottom: "1px solid #dddddd"
  },
  appPageTableRowContent: {
    padding: "0 24px",
    overflowX: "auto",
    [theme.breakpoints.down("xs")]: {
      padding: "0 16px"
    }
  },
  rowContent: {
    height: 48,
    width: "100%",
    display: "grid",
    gridTemplateColumns:
      "minmax(120px, 2fr) minmax(120px, 2fr) minmax(85px, 2fr) minmax(85px, 2fr) minmax(85px, 2fr) minmax(85px, 2fr)",
    gap: 4,
    alignItems: "center"
  },
  rowCell: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis"
  },
  rowCellCenter: {
    textAlign: "center"
  },
  tableHeaderContainer: {
    overflow: "hidden",
    paddingTop: 10,
    paddingBottom: 9
  },
  actionButton: {
    marginLeft: 8,
    marginRight: 8
  },
  virtualList: {
    "& &__item--odd": {
      backgroundColor: theme.palette.common.white
    },
    "& &__item--even": {
      backgroundColor: "#f6f6f6"
    }
  },
  virtualListItem: {
    width: "100%",
    borderBottom: "1px solid #eee"
  },
  overlayLoader: {
    left: 1
  }
}));
